var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"button-main-dialog font-weight-medium",class:{ 'font--text': _vm.cancel, cancel: _vm.cancel },style:({ opacity: _vm.computedOpacity }),attrs:{"elevation":"0","dark":_vm.$attrs.disabled}},'v-btn',Object.assign({}, {small: _vm.small,
    outlined: _vm.cancel,
    color: _vm.cancel ? undefined : _vm.color},
    _vm.$attrs),false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.computedText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }